import { useState } from 'react'
import { X } from 'lucide-react'
import { PLANS_DISABLED } from '../../flags'

const DISMISSED_KEY = 'od_dev_billing_banner_dismissed'

/**
 * Shown only in local dev (import.meta.env.DEV) when PLANS_DISABLED=true.
 * Reminds developers that billing gates are bypassed so they don't mistake
 * dev behaviour for production behaviour.
 */
export default function DevBillingBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(DISMISSED_KEY) === '1' } catch { return false }
  })

  if (!import.meta.env.DEV || !PLANS_DISABLED || dismissed) return null

  function dismiss() {
    try { sessionStorage.setItem(DISMISSED_KEY, '1') } catch { /* ignore */ }
    setDismissed(true)
  }

  return (
    <div
      role="status"
      aria-label="Development billing notice"
      style={{
        background: 'rgba(254, 243, 199, 0.9)',
        borderBottom: '1px solid rgba(217, 119, 6, 0.25)',
        padding: '5px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 8,
        fontSize: 12,
        lineHeight: '16px',
        color: '#92400E',
        fontFamily: 'inherit',
      }}
    >
      <span>
        <strong style={{ fontWeight: 600 }}>Dev:</strong> billing gates disabled —{' '}
        <code
          style={{
            background: 'rgba(217, 119, 6, 0.12)',
            padding: '1px 5px',
            borderRadius: 3,
            fontFamily: 'monospace',
            fontSize: 11,
          }}
        >
          VITE_PLANS_DISABLED=true
        </code>
        . Remove this flag or set it to{' '}
        <code
          style={{
            background: 'rgba(217, 119, 6, 0.12)',
            padding: '1px 5px',
            borderRadius: 3,
            fontFamily: 'monospace',
            fontSize: 11,
          }}
        >
          false
        </code>{' '}
        to test seat limits and trial enforcement.
      </span>
      <button
        onClick={dismiss}
        aria-label="Dismiss billing notice"
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: 2,
          color: '#92400E',
          opacity: 0.7,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <X size={13} />
      </button>
    </div>
  )
}
